import { css, cx } from '@emotion/css';
import React from 'react';

export interface SectionTitleProps extends Omit<React.HTMLAttributes<HTMLHeadingElement>, 'children'> {
  children: React.ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}

const sectionTitleStyle = css({
  position: 'relative',
  fontSize: '1.75rem',
  fontWeight: 700,
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '-0.15em',
    left: '0',
    width: '100px',
    height: '4px',
    backgroundColor: '#e7c7af',
    borderRadius: '4px',
  },
  '@media (max-width: 768px)': {
    fontSize: '1.5rem',
    '&:after': {
      width: '80px',
      height: '3px',
    },
  },
  '@media (max-width: 480px)': {
    fontSize: '1.25rem',
    '&:after': {
      width: '60px',
      height: '3px',
    },
  },
});

export const SectionTitle = React.forwardRef<HTMLHeadingElement, SectionTitleProps>(
  ({ className, level = 2, children, ...rest }, ref) => {
    const Tag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    
    return React.createElement(
      Tag,
      {
        ref,
        className: cx(sectionTitleStyle, className),
        ...rest,
      },
      children
    );
  }
);

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;